import React, { useEffect, useContext, useState } from 'react'
import { ErpClientContext } from '../../services/erp'
import { message } from 'antd'
import './index.css'

export default function EditMatchs() {
  const erpService = useContext(ErpClientContext)
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredProducts, setFilteredProducts] = useState([])
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const pageSizeOptions = [10, 20, 30, 40, 50]
  const [selectedProvider, setSelectedProvider] = useState('all')
  const [providers, setProviders] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingProduct, setEditingProduct] = useState(null)
  const [editForm, setEditForm] = useState({
    id_producto: '',
    excluir_venta: false,
  })

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    // Extraer proveedores únicos de los productos
    if (products.length > 0) {
      const idToName = new Map()
      for (const p of products) {
        if (p.id_proveedor && !idToName.has(p.id_proveedor)) {
          idToName.set(p.id_proveedor, p.nombre_proveedor)
        }
      }
      const uniqueProviders = Array.from(
        idToName.entries()
      ).map(([id, name]) => ({ id, name }))
      setProviders(uniqueProviders)
    }
  }, [products])

  useEffect(() => {
    const filtered = products.filter((product) => {
      const matchesSearch = Object.values(product).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
      const matchesProvider =
        selectedProvider === 'all' || product.id_proveedor === selectedProvider
      return matchesSearch && matchesProvider
    })
    setFilteredProducts(filtered)
    setCurrentPage(1)
  }, [searchTerm, selectedProvider, products])

  async function init() {
    const res = await erpService.getProductsWithMatch()
    console.log(res)
    setProducts(res)
    setFilteredProducts(res)
  }

  async function handleDeleteMatch(product) {
    setLoading({ ...loading, [`delete-${product.id_producto}`]: true })
    try {
      await erpService.deleteMatch({
        id_proveedor: product.id_proveedor,
        id_producto_proveedor: product.id_producto_proveedor,
        id_producto: product.id_producto,
      })

      message.success('Match eliminado correctamente')
      await init() // Recargar datos
    } catch (error) {
      message.error(`Error al eliminar match: ${error.message}`)
      console.error('Error al eliminar match:', error)
    }
    setLoading({ ...loading, [`delete-${product.id_producto}`]: false })
  }

  const handleEditClick = (product) => {
    setEditingProduct(product)
    setEditForm({
      id_producto: product.id_producto,
      excluir_venta: Boolean(product.excluir_venta),
    })
    setIsModalOpen(true)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
    setEditingProduct(null)
    setEditForm({ id_producto: '', excluir_venta: false })
  }

  async function handleEditSubmit(e) {
    e.preventDefault()
    if (!editingProduct) return

    setLoading({ ...loading, [`edit-${editingProduct.id_producto}`]: true })
    try {
      await erpService.editMatchs({
        id_proveedor: editingProduct.id_proveedor,
        id_producto_proveedor: editingProduct.id_producto_proveedor,
        id_producto_old: editingProduct.id_producto,
        id_producto_new: editForm.id_producto,
        excluir_venta: editForm.excluir_venta,
      })

      message.success('Match actualizado correctamente')
      await init() // Recargar datos
      handleModalClose()
    } catch (error) {
      message.error(`Error al editar match: ${error.message}`)
      console.error('Error al editar match:', error)
    }
    setLoading({ ...loading, [`edit-${editingProduct.id_producto}`]: false })
  }

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem)
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage)

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value)
    setItemsPerPage(newSize)
    setCurrentPage(1)
  }

  const renderPageNumbers = () => {
    const pageNumbers = []
    const maxVisiblePages = 5
    let startPage = Math.max(1, currentPage - 2)
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1)

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => setCurrentPage(i)}
          style={{
            ...buttonStyle,
            backgroundColor: currentPage === i ? '#1890ff' : '#fff',
            color: currentPage === i ? '#fff' : '#1890ff',
            border: '1px solid #1890ff',
          }}
        >
          {i}
        </button>
      )
    }
    return pageNumbers
  }

  const buttonStyle = {
    border: 'none',
    padding: '5px 10px',
    borderRadius: '4px',
    cursor: 'pointer',
    margin: '0 5px',
  }

  return (
    <div
      className="container"
      style={{ backgroundColor: '#fff', padding: '30px' }}
    >
      <div className="level-left">
        <h2 className="title is-size-5">Productos con Match</h2>
      </div>

      <div
        style={{
          marginBottom: '20px',
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
        }}
      >
        <input
          type="text"
          placeholder="Buscar..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: '8px',
            width: '200px',
            borderRadius: '4px',
            border: '1px solid #ddd',
          }}
        />
        <select
          value={selectedProvider}
          onChange={(e) => setSelectedProvider(e.target.value)}
          style={{
            padding: '8px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            width: '150px',
          }}
        >
          <option value="all">Todos los proveedores</option>
          {providers.map((provider) => (
            <option key={provider.id} value={provider.id}>
              {provider.name}
            </option>
          ))}
        </select>
      </div>

      <div className="Table">
        <div className="Heading">
          <div className="Cell">ID Proveedor</div>
          <div className="Cell">ID Producto</div>
          <div className="Cell">ID Producto Proveedor</div>
          <div className="Cell">Nombre</div>
          <div className="Cell">Añada</div>
          <div className="Cell">Capacidad</div>
          <div className="Cell">Familia Producto</div>
          <div className="Cell">Graduación</div>
          <div className="Cell">PVP Proveedor</div>
          <div className="Cell">Stock</div>
          <div className="Cell">Surtido</div>
          <div className="Cell">Excluir Venta</div>
          <div className="Cell">Acciones</div>
        </div>

        {currentItems.map((product) => (
          <div
            className="Row"
            key={`${product.nombre_proveedor}-${product.id_producto}`}
          >
            <div className="Cell">{product.nombre_proveedor}</div>
            <div className="Cell">{product.id_producto}</div>
            <div className="Cell">{product.id_producto_proveedor}</div>
            <div className="Cell">{product.name}</div>
            <div className="Cell">{product.anyada || '-'}</div>
            <div className="Cell">{product.capacidad || '-'}</div>
            <div className="Cell">{product.familia_producto || '-'}</div>
            <div className="Cell">{product.graduacion || '-'}</div>
            <div className="Cell">{product.pvp_proveedor || '-'}</div>
            <div className="Cell">{product.stock}</div>
            <div className="Cell">{product.surtido || '-'}</div>
            <div className="Cell" style={{ textAlign: 'center' }}>
              {product.excluir_venta ? 'SI' : 'NO'}
            </div>
            <div
              className="Cell"
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <button
                onClick={() => handleEditClick(product)}
                disabled={loading[`edit-${product.id_producto}`]}
                style={{
                  ...buttonStyle,
                  backgroundColor: '#1890ff',
                  color: 'white',
                }}
              >
                {loading[`edit-${product.id_producto}`]
                  ? 'Editando...'
                  : 'Editar'}
              </button>
              <button
                onClick={() => handleDeleteMatch(product)}
                disabled={loading[`delete-${product.id_producto}`]}
                style={{
                  ...buttonStyle,
                  backgroundColor: '#ff4d4f',
                  color: 'white',
                }}
              >
                {loading[`delete-${product.id_producto}`]
                  ? 'Eliminando...'
                  : 'Eliminar'}
              </button>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '20px',
          gap: '5px',
        }}
      >
        <button
          onClick={() => setCurrentPage(1)}
          disabled={currentPage === 1}
          style={{
            ...buttonStyle,
            backgroundColor: '#fff',
            color: '#1890ff',
            border: '1px solid #1890ff',
            opacity: currentPage === 1 ? 0.5 : 1,
          }}
        >
          {'<<'}
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          style={{
            ...buttonStyle,
            backgroundColor: '#fff',
            color: '#1890ff',
            border: '1px solid #1890ff',
            opacity: currentPage === 1 ? 0.5 : 1,
          }}
        >
          {'<'}
        </button>

        {renderPageNumbers()}

        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          style={{
            ...buttonStyle,
            backgroundColor: '#fff',
            color: '#1890ff',
            border: '1px solid #1890ff',
            opacity: currentPage === totalPages ? 0.5 : 1,
          }}
        >
          {'>'}
        </button>
        <button
          onClick={() => setCurrentPage(totalPages)}
          disabled={currentPage === totalPages}
          style={{
            ...buttonStyle,
            backgroundColor: '#fff',
            color: '#1890ff',
            border: '1px solid #1890ff',
            opacity: currentPage === totalPages ? 0.5 : 1,
          }}
        >
          {'>>'}
        </button>
      </div>

      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <select
          value={itemsPerPage}
          onChange={handlePageSizeChange}
          style={{
            padding: '5px',
            borderRadius: '4px',
            border: '1px solid #ddd',
            marginTop: '10px',
          }}
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size} / página
            </option>
          ))}
        </select>
      </div>

      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        Mostrando {indexOfFirstItem + 1} -{' '}
        {Math.min(indexOfLastItem, filteredProducts.length)} de{' '}
        {filteredProducts.length} resultados
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '400px',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            }}
          >
            <h3 style={{ marginBottom: '20px' }}>Editar Producto</h3>
            <form onSubmit={handleEditSubmit}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>
                  ID Producto:
                </label>
                <input
                  type="text"
                  value={editForm.id_producto}
                  onChange={(e) =>
                    setEditForm({
                      ...editForm,
                      id_producto: e.target.value,
                    })
                  }
                  style={{
                    width: '100%',
                    padding: '8px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                  }}
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <input
                    type="checkbox"
                    checked={editForm.excluir_venta}
                    onChange={(e) =>
                      setEditForm({
                        ...editForm,
                        excluir_venta: e.target.checked,
                      })
                    }
                    style={{ width: '18px', height: '18px' }}
                  />
                  Excluir Venta
                </label>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                }}
              >
                <button
                  type="button"
                  onClick={handleModalClose}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                  }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={loading[`edit-${editingProduct?.id_producto}`]}
                  style={{
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: 'none',
                    backgroundColor: '#1890ff',
                    color: 'white',
                    cursor: 'pointer',
                  }}
                >
                  {loading[`edit-${editingProduct?.id_producto}`]
                    ? 'Guardando...'
                    : 'Guardar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
